import { IAriaLabels } from '@models/IAriaLabels';
import ariaLabels from '@utils/mocks/ariaLabels.mocks';
import create from 'zustand';

interface IAriaLabelsState {
  ariaLabels: IAriaLabels;
  setAriaLabels: (ariaLabels: IAriaLabels) => void;
}

const useAriaLabelsStore = create<IAriaLabelsState>((set) => ({
  ariaLabels,
  setAriaLabels: (ariaLabels: IAriaLabels) => set({ ariaLabels }),
}));

export default useAriaLabelsStore;
